import { gql } from "@apollo/client"

const UPLOAD_ASSET = gql `
  mutation uploadAsset($input: UploadAssetInput!) {
    uploadAsset(input: $input) {
      id
      filename
      type {
        id
        code
        type
        rules
      }
    }
  }
`

export { UPLOAD_ASSET }
